/**
 * Registers GSAP ScrollTrigger once for all sections.
 * GSAP + ScrollTrigger loaded before this file in theme.liquid.
 */
(function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  window.AV = window.AV || {};
  window.AV.gsapReady = true;

  document.dispatchEvent(new CustomEvent('av:gsap-ready'));
})();
